import { trpc } from '@/shared/api';

/** HOME 기업 고객 사례 목록 캐시 무효화 함수를 돌려준다. */
export const useInvalidateLandingTestimonials = (): (() => void) => {
  const utils = trpc.useUtils();

  return () => void utils.landing.listTestimonialsAdmin.invalidate();
};
